import React from 'react';
import styles from './index.module.less';
import { HairShareBloggerInfoModel } from '@/types/hairstyle';
import { getColorFromString, imgUrl } from '@/shared/utils';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Image from 'next/image';

const InfluencersCardItemContent = ({ item }: { item?: HairShareBloggerInfoModel }) => {
  const router = useRouter();

  return (
    <div
      className={styles.content}
      onClick={() => {
        if (item) {
          router?.push(`/influencers/${item?.nickname}`);
        }
      }}
    >
      <div className={styles.topContenter}>
        {(item?.images ?? []).map((tempItem) => {
          return (
            <Image
              key={tempItem?.lib_id}
              className={styles.picture}
              src={imgUrl(tempItem?.image_url, 'small')}
              alt={tempItem?.image_alt}
              loading="lazy"
              width={200}
              height={200}
            />
          );
        })}
      </div>

      <div className={styles.bottomContainer}>
        <Link href={item?.homepage ?? ''} target="__block" onClick={(e) => e.stopPropagation()}>
          <Image
            className={styles.icon}
            src={imgUrl(item?.avatar, 'mid')}
            alt={item?.nickname}
            loading="lazy"
            width={74}
            height={74}
          />
        </Link>
        <p className={styles.name}>{item?.nickname}</p>
        <p className={styles.followers}>{`${item?.follower_num} followers`}</p>
        <p className={styles.hairstyleCount}>{`${item?.hairstyle_num} Hairstyle`}</p>

        <div className={styles.labelList}>
          {(item?.labels ?? []).map((tempItem, index) => {
            return (
              <span key={`${index}-${tempItem}`} style={{ background: getColorFromString(tempItem) }}>
                {tempItem}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InfluencersCardItemContent;
